import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 234px;\n  height: 55px;\n  padding: 10px 24px;\n  list-style-type: none;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  cursor: pointer;\n\n  @media screen and (max-width: ", "px) {\n    width: auto;\n    height: 60px;\n    padding: 10px 20px;\n  }\n\n  &:hover {\n    background: ", ";\n    &:first-child {\n      border-radius: ", "\n        0 0;\n    }\n    &:last-child {\n      border-radius: 0 0\n        ", ";\n    }\n    &:only-child {\n      border-radius: ", ";\n    }\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import Ink from 'react-ink';
import posed from 'react-pose';
import CheckPaddedSVG from '../assets/icons/check-padded.svg';
import styled from '../utils/styling/styled-components';
import { Bodytext } from '../Typography';
import { DROPDOWN_ITEM } from '../utils/testing/TestIDs';
/**
 * DropdownItem is the individual list item that goes inside of a
 * DropdownMenu. They are composed of a text label and a check icon
 * which can be shown or hidden depending on if the item is the currently
 * selected item or not. They look a little something like:
 *
 *    --------------------
 *    | Core             |
 *    --------------------
 *
 */

var Container = styled.li(_templateObject(), function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.colors.ivoryLight;
}, function (props) {
  return props.theme.borderRadius.large + ' ' + props.theme.borderRadius.large;
}, function (props) {
  return props.theme.borderRadius.large + ' ' + props.theme.borderRadius.large;
}, function (props) {
  return props.theme.borderRadius.large;
});
var Image = styled.img(_templateObject2());
var Check = posed(Image)({
  show: {
    opacity: 1
  },
  hide: {
    opacity: 0,
    transition: {
      duration: 0
    }
  }
});

var DropdownItem = function DropdownItem(_ref) {
  var label = _ref.label,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": DROPDOWN_ITEM,
    onClick: onClick,
    className: className
  }, /*#__PURE__*/React.createElement(Bodytext, null, label), /*#__PURE__*/React.createElement(Check, {
    initialPose: "exit",
    pose: selected ? 'show' : 'hide',
    src: CheckPaddedSVG,
    alt: selected ? 'selected' : 'not selected'
  }), /*#__PURE__*/React.createElement(Ink, {
    opacity: 0.02
  }));
};

export { DropdownItem };